import { render, staticRenderFns } from "./ReportsDeliveryMovementView.vue?vue&type=template&id=23d84f77"
import script from "./ReportsDeliveryMovementView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliveryMovementView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports